import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0 0 1rem 1rem',
    backgroundColor: '#f7f8f9'
  },

  alert: {
    position: 'absolute',
    bottom: ({ verified }) => (verified ? '-3rem' : 'unset'),
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },

  files: {
    display: 'flex',
    flexWrap: 'wrap'
  }
}))

export default useStyles
